import LayoutManager from "../../../../../lib/html5-software-library/src/ranj/layout/LayoutManager";
import MediatorManager from "../../../core/application/MediatorManager";
import AbstractMediator from "../../../core/ui/AbstractMediator";
import ClickEaterFactory from "../../../core/ui/ClickEaterFactory";
import SkinKeyRegistry from "../../../core/ui/SkinKeyRegistry";
import LaptopNavigateEvent from "../../../ngt/laptop/model/LaptopNavigateEvent";
import DashboardOpenerMediator from "../../dashboard/view/DashboardOpenerMediator";
import InternalStakeholdersMediator from "../../internal-stakeholders/view/InternalStakeholdersMediator";
import KeyDecisionEvent from "../../key-decisions/event/KeyDecisionEvent";
import KeyDecisionInteractionEvent from "../../key-decisions/event/KeyDecisionInteractionEvent";
import MapFactory from "../../map/controller/MapFactory";
import MapModel from "../../map/model/MapModel";
import TeaCornerOpenerMediator from "../../tea-corner/view/TeaCornerOpenerMediator";
import TimerMediator from "../../timer/view/TimerMediator";
import HubKeyDecisionListMediator from "./HubKeyDecisionListMediator";

export default class HubScreenMediator extends AbstractMediator {
    /**
     * @constructor
     * @param {createjs.MovieClip} target 
     * @param {soma.EventDispatcher} dispatcher 
     * @param {LayoutManager} layoutManager 
     * @param {ClickEaterFactory} clickEaterFactory 
     * @param {MediatorManager} mediatorManager 
     * @param {MapModel} mapModel 
     * @param {MapFactory} mapFactory 
     */
    constructor(target, dispatcher, layoutManager, clickEaterFactory, mediatorManager, mapModel, mapFactory, keyDecisionsModel) {
        super(target, dispatcher, layoutManager, clickEaterFactory);


        this._keyDecisionsModel = keyDecisionsModel;
        this._mediatorManager = mediatorManager;
        this._mapModel = mapModel;
        this._mapFactory = mapFactory;

        this._hasFocus = true;

        this._currentChapter = null;

        this._queuedAvailableKeyDecisionEvents = [];
    }

    initialize() {
        super.initialize();

        // TEMP: init with first chapter
        const firstChapter = 1
        this._currentChapter = firstChapter;


        this._laptopMediator = this._mediatorManager.createMediator(this._target.laptopButton, SkinKeyRegistry.LAPTOP_OPENER_MEDIATOR);
        this._smartphoneMediator = this._mediatorManager.createMediator(this._target.smartphoneButton, SkinKeyRegistry.SMARTPHONE_OPENER);
        /** @type {HubKeyDecisionListMediator} */
        this._keyDecisionListMediator = this._mediatorManager.createMediator(this._target.keyDecisionsContainer, SkinKeyRegistry.HUB_KEY_DECISION_LIST_SKIN);
        /** @type {InternalStakeholdersMediator} */
        this._internalStakeholdersMediator = this._mediatorManager.createMediator(this._target.internalStakeholders, SkinKeyRegistry.INTERNAL_STAKEHOLDERS);
        /** @type {TeaCornerOpenerMediator} */
        this._teaCornerOpenerMediator = this._mediatorManager.createMediator(this._target.teaCorner, SkinKeyRegistry.TEA_CORNER_OPENER);
        /** @type {TimerMediator} */
        this._timerMediator = this._mediatorManager.createMediator(this._target.timerKeyDecision, SkinKeyRegistry.TIMER);


        this._keyDecisionListMediator.initializeKeyDecisions(this._keyDecisionsModel.getNumberKeyDecisionByChapter(this._currentChapter));


        this._initializeMap();
        this._initializeDashboard();

        this.registerEventListener(KeyDecisionEvent.KEY_DECISION_AVAILABLE, this._handleKeyDecisionAvailable.bind(this));
        this.registerEventListener(KeyDecisionEvent.KEY_DECISION_UNAVAILABLE, this._handleKeyDecisionUnavailable.bind(this));

        this.registerEventListener(KeyDecisionInteractionEvent.CONFIRM_KEY_DECISION_SEEN, this._handleConfirmKeyDecisionSeen.bind(this));

        this.registerEventListener(LaptopNavigateEvent.LAPTOP_SHOW_REQUEST, this._handleBlur.bind(this));
        this.registerEventListener(LaptopNavigateEvent.LAPTOP_HIDE_REQUEST, this._handleFocus.bind(this));
    }

    destroy() {
        super.destroy();

        this._laptopMediator.destroy();
        this._smartphoneMediator.destroy();
        this._keyDecisionListMediator.destroy();
        this._internalStakeholdersMediator.destroy();
        this._teaCornerOpenerMediator.destroy();
        this._timerMediator.destroy();
        this._dashboardOpenerMediator.destroy();

        this._laptopMediator = null;
        this._smartphoneMediator = null;
        this._keyDecisionListMediator = null;

        if (this._mapMediator) {
            this._mapMediator.destroy();
            this._mapMediator = null;

            this._target.mapContainer.removeAllChildren();
        }
    }

    _initializeMap() {
        this._mapMediator = this._mapFactory.createMap(this._target.mapContainer, this._mapModel.currentMapId);
    }

    _initializeDashboard() {
        /** @type {DashboardOpenerMediator} */
        this._dashboardOpenerMediator = this._mediatorManager.createMediator(this._target.dashboardButton, SkinKeyRegistry.DASHBOARD_OPENER);
    }

    _handleKeyDecisionAvailable(evt) {
        /** @type {KeyDecisionEvent} */
        const data = evt.params.data;
        const keyDecision = data.keyDecision;

        const notifyKeyDecisionEvent = new KeyDecisionInteractionEvent(KeyDecisionInteractionEvent.NOTIFY_KEY_DECISION_AVAILABLE, keyDecision);
        if (this._hasFocus) {
            this.dispatch(notifyKeyDecisionEvent.type, { data: notifyKeyDecisionEvent });
        } else {
            this._queuedAvailableKeyDecisionEvents.push(notifyKeyDecisionEvent);
        }
    }

    _handleKeyDecisionUnavailable(evt) {
        /** @type {KeyDecisionEvent} */
        const data = evt.params.data;
        const keyDecision = data.keyDecision;
        this._keyDecisionListMediator.makeKeyDecisionPerformed(keyDecision);
    }

    _handleConfirmKeyDecisionSeen(evt) {
        const data = evt.params.data;
        const keyDecision = data.keyDecision;
        this._keyDecisionListMediator.makeKeyDecisionAvailable(keyDecision);
    }

    _handleBlur() {
        this._hasFocus = false;
    }

    _handleFocus() {
        this._hasFocus = true;
        this._showNextQueuedAvailableKeyDecision();
    }

    _showNextQueuedAvailableKeyDecision() {
        if (this._queuedAvailableKeyDecisionEvents.length === 0) {
            return;
        }

        const nextAvailableKeyDecisionEvent = this._queuedAvailableKeyDecisionEvents.shift();
        this._dispatcher.dispatch(nextAvailableKeyDecisionEvent.type, { data: nextAvailableKeyDecisionEvent });
    }
}